import styled from "styled-components";

export const ComingSoon = styled.div`
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #e8e8eb;
  background: #fff;
  font-weight: 600;
  font-size: 18px;
  box-shadow: 0px 2px 4px 0px #1516331f;
`;

export const CenterPost = styled.div`
  margin-top: 5px;
  display: flex;
  justify-content: center;
`;
